/**
 * `POST /job-apply/api/billing-portal` — abre una sesión del portal de clientes
 * de Stripe (cambiar tarjeta, ver facturas, cancelar) que vuelve a /perfil/plan.
 *
 * Un estado y no un `throw`, como `couponClient`: "no tienes cuenta de cobro"
 * (409 `no_billing_account`: cortesía o pago viejo) se le dice distinto que
 * "falló, inténtalo de nuevo". A la primera, repetir no la arregla.
 */
import { apiFetch } from '~/lib/api';

export type BillingPortalResult =
  | { status: 'ok'; url: string }
  /** No tiene cliente en Stripe: el cambio se hace con nosotros. */
  | { status: 'no_billing_account' }
  /** 401, 500, respuesta sin URL o la red caída. */
  | { status: 'failed' };

export async function openBillingPortal(): Promise<BillingPortalResult> {
  let res: Response;
  try {
    res = await apiFetch('/job-apply/api/billing-portal', { method: 'POST' });
  } catch {
    return { status: 'failed' };
  }

  const body = (await res.json().catch(() => ({}))) as { url?: string; code?: string };

  if (res.ok && typeof body.url === 'string' && body.url) return { status: 'ok', url: body.url };
  if (res.status === 409 || body.code === 'no_billing_account') return { status: 'no_billing_account' };
  return { status: 'failed' };
}
